const settings = {
  b64Image: {
    MaxWidth: 100,
    MaxHeight: 100
  },
}

export {
  settings
}
